export default __webpack_public_path__ + "static/media/mainLogo.3289ab80.svg";